import { useLocation } from 'preact-iso';
import { Wordmark } from './Wordmark';
import { Button } from './Button';
import { logout, type SessionUser } from '../lib/auth';

type Link = { href: string; label: string };

type Props = {
  user: SessionUser;
  badge?: string;      // e.g. "Admin"
  links?: Link[];      // quick links on the right (e.g. My diary / Admin)
};

// Shared top bar for signed-in pages (user dashboard + admin). One header, the
// page supplies its own sub-nav (e.g. admin tabs) below it.
export function AppHeader({ user, badge, links = [] }: Props) {
  const { route } = useLocation();
  return (
    <header
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '18px 24px', borderBottom: '1px solid var(--line)', gap: 16, flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <a href="/" style={{ textDecoration: 'none', display: 'inline-flex' }}>
          <Wordmark size={24} />
        </a>
        {badge && (
          <span
            style={{
              fontSize: 12, fontWeight: 700, letterSpacing: '0.04em',
              textTransform: 'uppercase', color: 'var(--ink-3)',
              background: 'var(--surface-2)', padding: '3px 8px', borderRadius: 8,
            }}
          >
            {badge}
          </span>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            style={{
              fontSize: 13, fontWeight: 600, color: 'var(--ink)', textDecoration: 'none',
              padding: '8px 14px', borderRadius: 10, background: 'var(--card)',
              boxShadow: '0 0 0 1px var(--line)',
            }}
          >
            {l.label}
          </a>
        ))}
        <span style={{ fontSize: 13, color: 'var(--ink-3)' }}>{user.email}</span>
        <Button variant="secondary" size="sm" onClick={() => logout().then(() => route('/auth'))}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
